import {useInjection} from "inversify-react";
import {useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {PriceApi, PriceCreateDto, PriceDto, PriceUpdateDto} from "../../api";
import PricesList from "./priceList";
import {Layout} from "antd";
import {Content} from "antd/lib/layout/layout";
import styles from "./priceListContainer.module.scss";

export default function PricesListContainer(props: PricesListContainerProps) {
    const apiService = useInjection(ApiService);
    const [prices, setPrices] = useState<PriceDto[] | null>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [newValues, setNewValues] = useState<PriceUpdateDto[]>([]);

    useEffect(() => {
        refreshPricesList();
    }, [])

    const refreshPricesList = async () => {
        try {
            const Prices = await apiService.getApi(PriceApi).apiPriceGet();
            let menuPrices = Prices.data.filter(p => p.menuEntryId === props.menuEntryId);
            if (menuPrices.length === 0) {
                let initPrice: PriceUpdateDto = {value: 0, description: ""}
                await props.onSubmit(initPrice);
                setPrices([initPrice])
            } else {
                setPrices(menuPrices);
            }
        } catch (e: any) {
            console.log(e.response.data);
        }
    }

    const onAddClicked = async () => {
        let newPrice = {value: 0, description: ""}
        await props.onSubmit(newPrice);
        setPrices([...prices!, newPrice]);
    }

    const onDeleteClicked = async (id: number, idx: number) => {
        const response = await apiService.getApi(PriceApi).apiPriceIdDelete(id)
        if (response.request.status !== 200) {
            console.log("Error occurred while deleting data"); //add some warning?
        } else {
            prices?.splice(idx, 1);
            setPrices([...prices!]);
        }
    }

    const onDelete = async (r: PriceDto) => {
        let idx = prices!.indexOf(r);
        if (r.id) {
            setIsLoading(true);
            try {
                await onDeleteClicked(r.id, idx);
            }finally {
                setIsLoading(false);
            }
        } else {
            prices?.splice(idx, 1)
            setPrices([...prices!]);
            props.onPriceDelete(r);
        }
    }

    return <>
        <Layout style={{backgroundColor: "white"}}>
            <Content>
                <Layout>
                    <Content className={styles.content}>
                        <PricesList
                            data={prices || null}
                            onAddClicked={onAddClicked}
                            newValues={newValues}
                            setNewValues={setNewValues}
                            onEdit={props.onEdit}
                            onPriceDelete={onDelete}
                            isLoading={isLoading}
                        />
                    </Content>
                </Layout>
            </Content>
        </Layout>
    </>
}

interface PricesListContainerProps {
    menuEntryId: number,
    onSubmit: (values: PriceCreateDto) => void,
    onEdit: (values: PriceUpdateDto[]) => void
    onPriceDelete: (record: PriceDto) => void;
}
